import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Container, Dropdown, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import Card from '../../../components/Card'
import CustomToggle from '../../../components/dropdowns'
import ShareOffcanvas from '../../../components/share-offcanvas'
import { apiHandler } from '../../../api/apihandler';
import { CHALLENGE_DETAILS } from "../../../api/constants";
import LoaderModal from '../../../components/loaderModal'

import StoriesSection from '../../../components/stories/storiesSection'
import CreatePostModal from '../../../components/createPost/createPostModal'
import PeopleYouMayKnowCard from '../../../components/peopleYouMayKnow/peopleYouMayKnowCard'
import FeedPostCard from '../../../components/feeds/feedPostCard'
import ChallengeCard from '../../../components/challenge/challengeCard'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
import { setPostModalShow, setCreatePostType } from '../../../store/setting/actions'
import CreatePostInputBox from '../../../components/createPost/createPostInputBox'
import { fetchTranslationLanguages } from '../../../utilities/translationLanguages.js';

const ChallengeDetails = () => {
    const dispatch = useDispatch()
    const { slug } = useParams();
    const profileData = JSON.parse(useSelector((state) => state.setting.setting.user_data));
    const [challenge, setChallenge] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [translationLanguages, setTranslationLanguages] = useState([]);
    
    const [isFirst, setIsFirst] = useState(true);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsFirst(false)
    }, [isFirst]);

    useEffect(() => {
        if (profileData?.user_setting?.is_dance_corner === 1) {
            dispatch(setCreatePostType("2"))
        } else if (profileData?.user_setting?.is_influencer === 1) {
            dispatch(setCreatePostType("3"))
        } else {
            dispatch(setCreatePostType("4"))
        }
        getChallengeDetail()
        getTranslationLanguages()
    }, [])

    async function getTranslationLanguages() {
        try {
            const { response: res, languages } = await fetchTranslationLanguages()
            if (res?.data?.response?.status === 200 && Array.isArray(languages)) {
                setTranslationLanguages(languages)
            }
        } catch (error) {
            console.error(error)
        }
    }

    function refreshApi() {
        getChallengeDetail()
    }

    async function getChallengeDetail() {
        setShowLoader(true)
        try {
            const res = await apiHandler(CHALLENGE_DETAILS, "POST", {
                post_id: slug
            })
            if (res.data?.response?.status === 200) {
                setChallenge(res?.data?.data?.userPost)
            } else {
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowLoader(false)
        }
    }


    return (
        <>
            <LoaderModal showLoader={showLoader} />

            <div className="content-page scroller">
                <Container>
                    <Row>
                        {/* order-2/order-lg-1: on mobile the Stories/People-you-may-know
                            column below shows above this instead of under it;
                            order-lg-1 restores the left position once side by side. */}
                        <Col lg={8} className="row m-0 p-0 mt-3 mt-lg-0 order-2 order-lg-1">
                            <Col sm={12}>
                                {/* <CreatePostModal
                                    postType={profileData?.user_setting?.is_dance_corner === 1 ? "2" :
                                        profileData?.user_setting?.is_influencer === 1 ? "3" : "4"}
                                    refreshApi={refreshApi}
                                    eventId={""} /> */}
                                <CreatePostInputBox
                                    postType={profileData?.user_setting?.is_dance_corner === 1 ? "2" :
                                        profileData?.user_setting?.is_influencer === 1 ? "3" : "4"}
                                    refreshApi={refreshApi}
                                    eventId={""} />
                            </Col>
                            <Col sm={12}>
                                {
                                    challenge ? <ChallengeCard elm={challenge} getChallengeList={refreshApi} challengeDetails={true} translationLanguages={translationLanguages} /> : null
                                }
                            </Col>
                        </Col>
                        <Col lg={4} className="order-1 order-lg-2">
                            <StoriesSection isMyStory={false}/>
                            <PeopleYouMayKnowCard />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default ChallengeDetails
